function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, useState } from "react";
import { Flex } from "sprout-ui-primitives";
import { useCombobox } from "downshift";
import { colors } from "@sprout/client-lib/dist/labels_next";
import Fuse from "fuse.js";
import { ScrollContainer as BaseScrollContainer } from "sprout-ui-dom/dist/ScrollContainer";
import { useLabelEditDialog_UpdateLabelMutation } from "sprout-graphql";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import styled from "styled-components";
import { media } from "sprout-ui-theme";
import BaseLabelsDialogInput from "../../LabelsDialog/LabelsDialogInput";
import LabelEditColorDialogLabels from "./LabelEditColorDialogLabels";
const stateReducer = (state, actionAndChanges)=>{
    const { type , changes  } = actionAndChanges;
    if (type === useCombobox.stateChangeTypes.InputBlur) return state;
    if (type === useCombobox.stateChangeTypes.InputChange) return _objectSpread({}, changes, {
        highlightedIndex: 0
    });
    return changes;
};
const ScrollContainer = styled(BaseScrollContainer)`
  padding-bottom: 12px;

  ${media.up("small")} {
    padding-bottom: 24px;
  }

  ${media.up("small", "touch")} {
    padding-top: 24px;
  }
`;
const LabelsDialogInput = styled(BaseLabelsDialogInput)`
  margin-top: 24px;
  margin-bottom: 20px;
`;
const LabelEditColorDialogInner = (props)=>{
    const { onRequestClose , label  } = props;
    const [filterInputValue, setInputValue] = useState("");
    const handleInputValueChange = (changes)=>{
        if (typeof changes.inputValue === "string") setInputValue(changes.inputValue);
    };
    const searcher = useMemo(()=>{
        return new Fuse(colors, {
            threshold: 0
        });
    }, []);
    const items = useMemo(()=>{
        return filterInputValue.length === 0 ? colors : searcher.search(filterInputValue).map(({ item  })=>item);
    }, [
        filterInputValue,
        searcher
    ]);
    const [updateLabel] = useLabelEditDialog_UpdateLabelMutation();
    const showSnackbar = useSnackbar();
    const handleChange = useCallback((changes)=>{
        const { selectedItem: style  } = changes;
        onRequestClose();
        if (!style) return;
        updateLabel({
            variables: {
                labelId: label.id,
                style
            },
            optimisticResponse: {
                updateLabelById: {
                    label: _objectSpread({}, label, {
                        style
                    }),
                    __typename: "UpdateLabelPayload"
                }
            }
        }).catch(()=>{
            showSnackbar.error();
        });
    }, [
        label,
        onRequestClose,
        showSnackbar,
        updateLabel
    ]);
    const { getInputProps , getComboboxProps , getMenuProps , getItemProps  } = useCombobox({
        stateReducer,
        /**
       * `defaultIsOpen: true` is required, because without it, the first
       * arrow down event will trigger it to be open, instead of highlighting
       * the next item.
       */ defaultIsOpen: true,
        inputValue: filterInputValue,
        onInputValueChange: handleInputValueChange,
        initialHighlightedIndex: 0,
        items,
        itemToString: useMemo(()=>(item)=>item || "", []),
        onSelectedItemChange: handleChange
    });
    return /*#__PURE__*/ _jsxs(Flex, _objectSpread({
        flexDirection: "column",
        minHeight: "0",
        px: 1
    }, getComboboxProps(), {
        children: [
            /*#__PURE__*/ _jsx(LabelsDialogInput, {
                onRequestClose: onRequestClose,
                hideOnTouchDevices: true,
                placeholder: "Pick a color for label",
                getInputProps: getInputProps
            }),
            /*#__PURE__*/ _jsx(ScrollContainer, _objectSpread({
                mx: -1
            }, getMenuProps(), {
                children: /*#__PURE__*/ _jsx(LabelEditColorDialogLabels, {
                    colors: items,
                    getItemProps: getItemProps
                })
            }))
        ]
    }));
};
export default LabelEditColorDialogInner;
